import React, { memo, ReactElement } from "react";
import classNames from "classnames";
import { isEmpty } from "@swiggy-private/js-utils";

import { Icon } from "./components/Icon";
import IntermediateText from "./components/intermediate-text/IntermediateText";
import { ValueText } from "./components/value-text";
import { RenderingDetailsMeta } from "@swiggy-private/cart-types";

import styles from "../BillDetailItem.scss";

interface ItemValueProps {
    itemKey: string;
    value?: string | number;
    intermediateText?: string;
    isNegative?: boolean;
    meta?: RenderingDetailsMeta;
    icon?: string;
    isInTooltip?: boolean;
    intermediateTextStyle?: string;
    onItemClick?: VoidFunction;
    isNested?: boolean;
}

const ItemValue = ({
    itemKey,
    icon,
    intermediateText,
    meta = {},
    value,
    isNegative = false,
    isInTooltip = false,
    intermediateTextStyle,
    onItemClick,
    isNested,
}: ItemValueProps): ReactElement | null => {
    if (isEmpty(value)) {
        return null;
    }

    const className = classNames(styles.displayValue, {
        [styles.displayValueInTooltip]: isInTooltip,
    });

    return (
        <div className={className} onClick={onItemClick} data-testid={`${itemKey}_ITEM_VALUE`}>
            <Icon icon={icon} />
            <IntermediateText
                meta={meta}
                intermediateTextStyle={intermediateTextStyle}
                intermediateText={intermediateText}
                isNested={isNested}
            />
            <ValueText value={value} isNegative={isNegative} meta={meta} itemKey={itemKey} />
        </div>
    );
};

export default memo(ItemValue);
